import React from 'react';
import './UI.css';

export interface CardProps {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  actions,
  children,
  onClick,
  style,
  className,
}) => {
  return (
    <section 
      className={`ns-card ${className || ''}`}
      onClick={onClick}
      style={style}
    >
      {(title || actions) && (
        <header className="ns-card-header">
          <div>
            {title && <h2 className="ns-card-title">{title}</h2>}
            {subtitle && (
              <p className="ns-card-subtitle">{subtitle}</p>
            )}
          </div>
          {actions && <div className="ns-card-actions">{actions}</div>}
        </header>
      )}
      <div className="ns-card-body">{children}</div>
    </section>
  );
};


